module.exports = __webpack_public_path__ + "static/media/nrktZp14Lx.1fc2d2cb.jpg";